
import React, { useLayoutEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";

export default function RefundPage() {
  const navigate = useNavigate();
  const pageTopRef = useRef(null);

  useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });

    if (pageTopRef.current) {
      pageTopRef.current.scrollIntoView({
        behavior: "auto",
        block: "start",
      });
    }
  }, []);

  const handleBack = () => {
    if (window.opener && !window.opener.closed) {
      window.close();
      return;
    }

    navigate(-1);
  };

  return (
    <div ref={pageTopRef} className="refund-page">
      <style>{`
        .refund-page {
          min-height: 100vh;
          background: #f7faf8;
          color: #111827;
          font-family: Inter, "Avenir Next", Arial, sans-serif;
          line-height: 1.65;
        }

        .refund-shell {
          max-width: 960px;
          margin: 0 auto;
          padding: 34px 24px 72px;
        }

        .refund-back {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          margin-bottom: 26px;
          color: #148a58;
          font-size: 14px;
          font-weight: 650;
          text-decoration: none;
        }

        .refund-back:hover {
          text-decoration: underline;
        }

        .refund-back-button {
          border: none;
          background: transparent;
          padding: 0;
          cursor: pointer;
          font-family: inherit;
        }

        .refund-hero {
          padding: 46px 44px;
          margin-bottom: 26px;
          border-radius: 28px;
          color: #ffffff;
          background: linear-gradient(135deg, #0c6943 0%, #148a58 100%);
          box-shadow: 0 18px 48px rgba(20, 138, 88, 0.16);
        }

        .refund-hero-label {
          display: inline-flex;
          padding: 6px 13px;
          margin-bottom: 18px;
          border: 1px solid rgba(255, 255, 255, 0.25);
          border-radius: 999px;
          background: rgba(255, 255, 255, 0.13);
          font-size: 12px;
          font-weight: 700;
          letter-spacing: 0.09em;
          text-transform: uppercase;
        }

        .refund-hero h1 {
          margin: 0 0 13px;
          font-size: clamp(34px, 5vw, 47px);
          font-weight: 760;
          line-height: 1.1;
          letter-spacing: -0.045em;
        }

        .refund-hero-description {
          max-width: 720px;
          margin: 0;
          color: rgba(255, 255, 255, 0.9);
          font-size: 16px;
        }

        .refund-meta {
          display: flex;
          flex-wrap: wrap;
          gap: 11px;
          margin-top: 30px;
        }

        .refund-meta-item {
          padding: 9px 13px;
          border: 1px solid rgba(255, 255, 255, 0.2);
          border-radius: 12px;
          background: rgba(255, 255, 255, 0.11);
          color: rgba(255, 255, 255, 0.94);
          font-size: 13px;
        }

        .refund-card {
          padding: 30px 32px;
          margin-bottom: 17px;
          border: 1px solid #e3ebe6;
          border-radius: 22px;
          background: #ffffff;
          box-shadow: 0 5px 22px rgba(17, 24, 39, 0.035);
        }

        .refund-card h2 {
          display: flex;
          align-items: center;
          gap: 12px;
          margin: 0 0 16px;
          color: #111827;
          font-size: 21px;
          font-weight: 720;
          letter-spacing: -0.02em;
        }

        .refund-number {
          flex-shrink: 0;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 34px;
          height: 34px;
          border-radius: 11px;
          background: #e9f6ef;
          color: #148a58;
          font-size: 14px;
          font-weight: 750;
        }

        .refund-card p {
          margin: 0 0 13px;
          color: #374151;
          font-size: 15px;
        }

        .refund-card p:last-child {
          margin-bottom: 0;
        }

        .refund-list {
          margin: 8px 0 0;
          padding-left: 21px;
          color: #374151;
          font-size: 15px;
        }

        .refund-list li {
          margin-bottom: 9px;
          padding-left: 3px;
        }

        .refund-list li:last-child {
          margin-bottom: 0;
        }

        .refund-highlight {
          padding: 18px 20px;
          margin-top: 18px;
          border-left: 4px solid #148a58;
          border-radius: 13px;
          background: #f1faf5;
          color: #244536;
          font-size: 14px;
        }

        .refund-notice {
          padding: 18px 20px;
          margin-top: 18px;
          border-left: 4px solid #d59b25;
          border-radius: 13px;
          background: #fffaf0;
          color: #594019;
          font-size: 14px;
        }

        .refund-link {
          color: #148a58;
          font-weight: 600;
          text-decoration: underline;
          text-underline-offset: 2px;
        }

        .refund-steps {
          display: grid;
          gap: 12px;
          margin-top: 18px;
        }

        .refund-step {
          display: flex;
          align-items: flex-start;
          gap: 13px;
          padding: 15px 16px;
          border: 1px solid #e3ebe6;
          border-radius: 14px;
          background: #f8fbf9;
        }

        .refund-step-number {
          flex-shrink: 0;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 26px;
          height: 26px;
          border-radius: 999px;
          background: #148a58;
          color: #ffffff;
          font-size: 13px;
          font-weight: 700;
        }

        .refund-step-text {
          color: #374151;
          font-size: 14px;
        }

        .refund-table-wrapper {
          width: 100%;
          margin-top: 20px;
          overflow-x: auto;
          border: 1px solid #e3ebe6;
          border-radius: 16px;
        }

        .refund-table {
          width: 100%;
          min-width: 700px;
          border-collapse: collapse;
          background: #ffffff;
          font-size: 14px;
        }

        .refund-table th {
          padding: 14px 15px;
          border-bottom: 1px solid #e3ebe6;
          background: #f1f7f3;
          color: #24372d;
          font-size: 13px;
          font-weight: 720;
          text-align: left;
        }

        .refund-table td {
          padding: 15px;
          border-bottom: 1px solid #edf2ee;
          color: #374151;
          vertical-align: top;
        }

        .refund-table tr:last-child td {
          border-bottom: none;
        }

        .refund-tag {
          display: inline-flex;
          padding: 4px 9px;
          border-radius: 999px;
          background: #e9f6ef;
          color: #0f6c45;
          font-size: 12px;
          font-weight: 720;
          white-space: nowrap;
        }

        .refund-tag-neutral {
          display: inline-flex;
          padding: 4px 9px;
          border-radius: 999px;
          background: #f1f5f9;
          color: #475569;
          font-size: 12px;
          font-weight: 720;
          white-space: nowrap;
        }

        .refund-documents {
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 12px;
          margin-top: 18px;
        }

        .refund-document-link {
          display: block;
          padding: 14px 15px;
          border: 1px solid #e3ebe6;
          border-radius: 13px;
          background: #f8fbf9;
          color: #148a58;
          font-size: 14px;
          font-weight: 650;
          text-decoration: none;
        }

        .refund-document-link:hover {
          border-color: #b8dcc8;
          background: #f1faf5;
        }

        .refund-approval {
          padding: 28px 32px;
          margin-top: 20px;
          margin-bottom: 17px;
          border-radius: 22px;
          border: 1px solid #d7eadf;
          background: #eff9f3;
        }

        .refund-approval h2 {
          margin: 0 0 12px;
          color: #10271e;
          font-size: 21px;
          font-weight: 720;
          letter-spacing: -0.02em;
        }

        .refund-approval p {
          margin: 0 0 12px;
          color: #374151;
          font-size: 15px;
        }

        .refund-approval p:last-child {
          margin-bottom: 0;
        }

        .refund-contact {
          padding: 30px 32px;
          margin-top: 20px;
          border-radius: 22px;
          background: #10271e;
          color: #ffffff;
        }

        .refund-contact h2 {
          margin: 0 0 10px;
          font-size: 21px;
          letter-spacing: -0.02em;
        }

        .refund-contact p {
          margin: 0 0 14px;
          color: rgba(255, 255, 255, 0.82);
          font-size: 15px;
        }

        .refund-contact a {
          color: #ffffff;
          font-weight: 650;
          text-decoration: underline;
          text-underline-offset: 3px;
        }

        .refund-footer {
          padding-top: 30px;
          color: #64748b;
          font-size: 13px;
          text-align: center;
        }

        @media (max-width: 640px) {
          .refund-shell {
            padding: 20px 15px 48px;
          }

          .refund-hero {
            padding: 32px 23px;
            border-radius: 21px;
          }

          .refund-card,
          .refund-approval,
          .refund-contact {
            padding: 23px 20px;
            border-radius: 18px;
          }

          .refund-card h2 {
            align-items: flex-start;
            font-size: 19px;
          }

          .refund-documents {
            grid-template-columns: 1fr;
          }
        }
      `}</style>

      <main className="refund-shell">
        <button
          type="button"
          className="refund-back refund-back-button"
          onClick={handleBack}
        >
          ← Back to EcoTrack
        </button>

        <header className="refund-hero">
          <div className="refund-hero-label">Legal Information</div>

          <h1>Refund and Cancellation Policy</h1>

          <p className="refund-hero-description">
            This Policy explains the rules governing cancellation of annual
            EcoTrack subscriptions, refund requests and billing-related issues
            for business and professional users.
          </p>

          <div className="refund-meta">
            <div className="refund-meta-item">Last updated: 31 May 2026</div>
            <div className="refund-meta-item">Viridis by Serap Cevirgen</div>
            <div className="refund-meta-item">VAT No. 04191120130</div>
          </div>
        </header>

        <section className="refund-card">
          <h2>
            <span className="refund-number">1</span>
            Scope
          </h2>

          <p>
            <strong>1.1</strong> This Refund and Cancellation Policy explains
            the rules applicable to EcoTrack paid subscriptions, automatic
            renewals, cancellation requests, refunds and billing-related
            issues.
          </p>

          <p>
            <strong>1.2</strong> EcoTrack is operated by{" "}
            <strong>Viridis by Serap Cevirgen</strong>, VAT No. 04191120130,
            referred to in this Policy as the <strong>Provider</strong>.
          </p>

          <p>
            <strong>1.3</strong> EcoTrack is intended exclusively for business
            and professional users acting in connection with a trade, business
            or professional activity, and not for private consumers acting
            outside such activity.
          </p>

          <p>
            <strong>1.4</strong> Nothing in this Policy excludes or limits any
            right or remedy that cannot lawfully be excluded or limited under
            mandatory applicable law.
          </p>
        </section>

        <section className="refund-card">
          <h2>
            <span className="refund-number">2</span>
            Subscription model and cancellation
          </h2>

          <p>
            <strong>2.1</strong> Unless stated otherwise during checkout,
            EcoTrack is offered through a yearly auto-renewing subscription.
          </p>

          <p>
            <strong>2.2</strong> Subscription renewal occurs automatically each
            year unless the customer cancels automatic renewal before the next
            renewal date.
          </p>

          <p>
            <strong>2.3</strong> Customers may initiate cancellation through
            the account-closure and subscription-cancellation control available
            in the <strong>Profile &amp; Settings</strong> section of EcoTrack.
            Where an active paid subscription exists, selecting{" "}
            <strong>Close account and cancel subscription</strong> redirects
            the customer to <strong>Stripe Customer Portal</strong>, where the
            customer securely completes cancellation of automatic renewal.
          </p>

          <p>
            <strong>2.4</strong> Cancellation of automatic renewal is completed
            only when confirmed through Stripe Customer Portal. Starting the
            account-closure flow, closing the Stripe page without completing
            cancellation or sending a support message does not by itself cancel
            renewal, unless the Provider expressly confirms that cancellation
            has been completed on the customer&apos;s behalf.
          </p>

          <p>
            <strong>2.5</strong> Unless otherwise shown in Stripe Customer
            Portal or required by mandatory law, cancellation takes effect at
            the end of the current paid billing period. The customer retains
            paid access until that period ends and will not be charged for a
            subsequent annual renewal.
          </p>

          <p>
            <strong>2.6</strong> Where the customer completes subscription
            cancellation as part of the EcoTrack account-closure flow, an
            account-deletion request is submitted to the Provider for
            processing in accordance with section 8 of this Policy.
          </p>

          <p>
  <strong>2.7</strong> Cancelling automatic renewal through Stripe prevents a
  future annual renewal charge after the active paid period ends. It does not
  automatically end paid access immediately, delete the account immediately or
  create a refund for fees already paid.
</p>
        </section>

        <section className="refund-card">
          <h2>
            <span className="refund-number">3</span>
            General refund rule
          </h2>

          <p>
            <strong>3.1</strong> Unless mandatory law requires otherwise, fees
            paid for EcoTrack are generally non-refundable once access to the
            digital service has been provisioned.
          </p>

          <p>
            <strong>3.2</strong> EcoTrack is a digital access service and not a
            physical product.
          </p>

          <p>
            <strong>3.3</strong> Cancellation of automatic renewal through
            Stripe prevents future renewal charges after the effective
            cancellation date, but does not by itself entitle the customer to a
            refund for the current or any previous paid subscription period.
          </p>

          <p>
            <strong>3.4</strong> A decision not to continue using EcoTrack
            after paid access has been activated does not by itself create a
            right to a refund.
          </p>
        </section>

        <section className="refund-card">
          <h2>
            <span className="refund-number">4</span>
            Situations where a refund may be granted
          </h2>

          <p>
            <strong>4.1</strong> Subject to verification, a refund may be
            granted where:
          </p>

          <div className="refund-table-wrapper">
            <table className="refund-table">
              <thead>
                <tr>
                  <th>Situation</th>
                  <th>Possible outcome</th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td>
                    Payment was successfully taken but paid access was not
                    activated due to a verified issue attributable to the
                    Provider.
                  </td>
                  <td>
                    <span className="refund-tag">Refund may apply</span>
                  </td>
                </tr>

                <tr>
                  <td>A duplicate payment occurred.</td>
                  <td>
                    <span className="refund-tag">Refund may apply</span>
                  </td>
                </tr>

                <tr>
                  <td>A proven billing error occurred.</td>
                  <td>
                    <span className="refund-tag">Refund may apply</span>
                  </td>
                </tr>

                <tr>
                  <td>
                    The service was materially unavailable due to a verified
                    technical issue attributable to the Provider and could not
                    reasonably be restored.
                  </td>
                  <td>
                    <span className="refund-tag">Refund may apply</span>
                  </td>
                </tr>

                <tr>
                  <td>A refund is required by mandatory applicable law.</td>
                  <td>
                    <span className="refund-tag">Refund required</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <p style={{ marginTop: 18 }}>
            <strong>4.2</strong> Where a refund is not required by mandatory
            law, the Provider may, where reasonable in the circumstances,
            propose another appropriate remedy, such as restoring access,
            correcting the verified issue, extending access time or applying a
            service credit.
          </p>
        </section>

        <section className="refund-card">
          <h2>
            <span className="refund-number">5</span>
            Situations where refunds are normally not granted
          </h2>

          <p>
            <strong>5.1</strong> Subject always to mandatory applicable law,
            refunds are normally not granted where:
          </p>

          <div className="refund-table-wrapper">
            <table className="refund-table">
              <thead>
                <tr>
                  <th>Situation</th>
                  <th>Normal position</th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td>The user successfully received access to EcoTrack.</td>
                  <td>
                    <span className="refund-tag-neutral">
                      Normally non-refundable
                    </span>
                  </td>
                </tr>

                <tr>
                  <td>The service was substantially used.</td>
                  <td>
                    <span className="refund-tag-neutral">
                      Normally non-refundable
                    </span>
                  </td>
                </tr>

                <tr>
                  <td>
                    Results, reports, suggestions or exports were generated.
                  </td>
                  <td>
                    <span className="refund-tag-neutral">
                      Normally non-refundable
                    </span>
                  </td>
                </tr>

                <tr>
                  <td>The request is based only on change of mind.</td>
                  <td>
                    <span className="refund-tag-neutral">
                      Normally non-refundable
                    </span>
                  </td>
                </tr>

                <tr>
                  <td>
                    The issue resulted from the user&apos;s device, unsupported
                    software, browser settings or local network conditions.
                  </td>
                  <td>
                    <span className="refund-tag-neutral">
                      Normally non-refundable
                    </span>
                  </td>
                </tr>

                <tr>
                  <td>
                    The user is dissatisfied with the interpretation or
                    usefulness of automated outputs while EcoTrack functioned
                    substantially as described.
                  </td>
                  <td>
                    <span className="refund-tag-neutral">
                      Normally non-refundable
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        <section className="refund-card">
          <h2>
            <span className="refund-number">6</span>
            How to cancel renewal or request a refund
          </h2>

          <p>
            <strong>6.1</strong> A customer who uses the EcoTrack account
            closure flow may cancel automatic renewal by opening{" "}
            <strong>Profile &amp; Settings</strong>, selecting{" "}
            <strong>Close account and cancel subscription</strong> and
            completing the cancellation steps in Stripe Customer Portal.
          </p>

          <p>
            <strong>6.2</strong> Refund requests, billing issues or requests
            for assistance with subscription cancellation may be submitted by
            email to{" "}
            <a
              className="refund-link"
              href="mailto:serap.cevirgen@viridisconsultancy.com"
            >
              serap.cevirgen@viridisconsultancy.com
            </a>
            .
          </p>

          <div className="refund-steps">
            <div className="refund-step">
              <span className="refund-step-number">1</span>
              <span className="refund-step-text">
                For account closure with subscription cancellation, open
                Profile &amp; Settings and choose <strong>Close account and
                cancel subscription</strong>.
              </span>
            </div>

            <div className="refund-step">
              <span className="refund-step-number">2</span>
              <span className="refund-step-text">
                Complete the subscription cancellation within Stripe Customer
                Portal. Renewal is not cancelled unless that step is completed
                or cancellation is separately confirmed by the Provider.
              </span>
            </div>

            <div className="refund-step">
              <span className="refund-step-number">3</span>
              <span className="refund-step-text">
                For a refund request or billing issue, contact the Provider
                from the email address linked to the EcoTrack account, where
                possible, and identify the relevant subscription or payment
                without sending complete card details.
              </span>
            </div>
          </div>

          <p style={{ marginTop: 18 }}>
            The Provider may request reasonable additional information needed
            to identify the relevant account, subscription or transaction and
            to verify the circumstances of a refund or billing request.
          </p>
        </section>

        <section className="refund-card">
          <h2>
            <span className="refund-number">7</span>
            Billing and payment disputes
          </h2>

          <p>
            <strong>7.1</strong> Payments are processed through Stripe or
            Stripe-supported payment methods.
          </p>

          <p>
            <strong>7.2</strong> Before initiating a chargeback or payment
            dispute, users are encouraged to contact the Provider directly so
            that any verified billing or access issue can be reviewed and, where
            appropriate, resolved.
          </p>

          <p>
            <strong>7.3</strong> Nothing in this Policy prevents a customer
            from exercising any payment-dispute or legal remedy available under
            applicable mandatory law or through the relevant payment provider.
          </p>
        </section>

        <section className="refund-card">
          <h2>
            <span className="refund-number">8</span>
            Account closure and subscription cancellation
          </h2>

          <p>
            <strong>8.1</strong> Subscription cancellation and deletion of an
            EcoTrack account are distinct actions, even where EcoTrack guides
            the customer through both actions within a single account-closure
            flow.
          </p>

          <p>
            <strong>8.2</strong> Where an active paid subscription exists, the
            <strong>Close account and cancel subscription</strong> function
            first redirects the customer to Stripe Customer Portal to complete
            cancellation of automatic renewal. Once cancellation is confirmed
            in that flow, an account-deletion request is submitted to the
            Provider for processing.
          </p>

          <p>
            <strong>8.3</strong> Where cancellation is scheduled at the end of
            the current paid term, access to EcoTrack normally remains
            available until that term expires. The Provider will take that paid
            access period into account when completing the account-deletion
            request, unless the customer specifically requests earlier deletion
            and accepts loss of remaining access, or earlier action is required
            by law or for security reasons.
          </p>

          <p>
            <strong>8.4</strong> A customer who wishes to cancel future renewal
            but keep the EcoTrack account or stored assessment history should
            contact the Provider for assistance before completing the
            account-deletion flow.
          </p>

          <p>
            <strong>8.5</strong> Deletion of account and assessment data does
            not require deletion of billing, invoice, tax, security or
            transaction records that the Provider or its payment provider must
            retain for legal, accounting or dispute-management purposes.
          </p>

          <p>
  <strong>8.6</strong> Completing cancellation in Stripe normally prevents
  future renewal while preserving access until the end of the current paid term.
  An account-deletion request is processed separately and does not itself create
  a right to a refund.
</p>
        </section>

        <section className="refund-card">
          <h2>
            <span className="refund-number">9</span>
            Related legal documents
          </h2>

          <p>
            This Policy should be read together with the Terms and Conditions
            and the other legal documents applicable to EcoTrack.
          </p>

          <div className="refund-documents">
            <Link className="refund-document-link" to="/terms-and-conditions">
              Terms and Conditions
            </Link>

            <Link className="refund-document-link" to="/privacy-policy">
              Privacy Policy
            </Link>

            <Link className="refund-document-link" to="/cookie-policy">
              Cookie Policy
            </Link>

            <Link className="refund-document-link" to="/legal-notice">
              Legal Notice
            </Link>
          </div>
        </section>

        <section className="refund-card">
          <h2>
            <span className="refund-number">10</span>
            Changes to this Policy
          </h2>

          <p>
            This Refund and Cancellation Policy may be updated from time to
            time to reflect changes in the EcoTrack service, subscription model,
            payment process or applicable legal requirements.
          </p>

          <p>
            The date displayed at the top of this page identifies the most
            recent update.
          </p>
        </section>

        <section className="refund-approval">
          <h2>Specific approval of refund limitations</h2>

          <p>
            During checkout, business and professional users are required to
            specifically approve the relevant contractual clauses relating to
            automatic renewal, subscription cancellation and refund
            limitations.
          </p>

          <p>
            In particular, the specific approval refers to{" "}
            <strong>
              section 2 concerning subscription renewal and cancellation,
              section 3 concerning the general refund rule and section 5
              concerning situations where refunds are normally not granted
            </strong>
            , together with the relevant provisions of the{" "}
            <Link className="refund-link" to="/terms-and-conditions">
              Terms and Conditions
            </Link>
            .
          </p>
        </section>

        <section className="refund-contact">
          <h2>Contact</h2>

          <p>
            Refund requests, billing issues or requests for help with
            subscription cancellation concerning EcoTrack may be sent to:
          </p>

          <a href="mailto:serap.cevirgen@viridisconsultancy.com">
            serap.cevirgen@viridisconsultancy.com
          </a>
        </section>

        <footer className="refund-footer">
          © 2026 Viridis by Serap Cevirgen · EcoTrack
        </footer>
      </main>
    </div>
  );
}